import { api } from '@helpers/api'
import { Card, Col, message, Row } from 'antd'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'


export const fetchSdrTeams = async (constant: string, t: (key: string) => string, filter: string) => {
  try {
    const response = await api.get('/constants')
    const filteredData = response.data[constant].filter(data =>
      data.toLowerCase().includes(filter.toLowerCase())
    )
    return filteredData
  } catch (error) {
    message.error(t('GETTEAMSERROR'))
  }
}

function RankingCards() {
  const { t } = useTranslation()
  const [data, setData] = useState<string[]>()

  useEffect(() => {
    const fetchData = async () => {
      const options = await fetchSdrTeams('USER_TAGS', t, 'opdc')
      setData(options)
    }
    fetchData()
  }, [])

  return (
    <Row gutter={[16, 16]}>
      {
        data?.map((data: string) => (
          <Col key={data} xl={8} xs={24} >
            <a href={`/tv/ranking/calls?tags=${data}`} >
              <Card data-cy={`rank_${data}`} type='inner' hoverable title={t(data)}>{t("CALLSDESCRIPTION")}</Card>
            </a>
          </Col>
        ))
      }
    </Row>
  )
}

export default RankingCards
